import React, { Component } from 'react';
import AdminOptionalsTable from './AdminOptionalsTable';

export class AdminOptionalsContent extends Component {
  render() {

    return (
      <AdminOptionalsTable titleTableList={this.props.titleTableList} />
    )

  }
}

export default AdminOptionalsContent


// WEBPACK FOOTER //
// ./src/components/Administration/AdminOptionals/AdminOptionalsContent.js